import { PayWithCard } from './pay-with-card/pay-with-card'
import { CardPaymentStatus } from './card-payment-status/card-payment-status'
import { PayWithSavedCard } from './pay-with-saved-card/pay-with-saved-card'

export const StripePaymentStack = {
  PayWithCardPage: PayWithCard,
  CardPaymentStatusPage: CardPaymentStatus,
  PayWithSavedCardPage: PayWithSavedCard,
}
